import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ThemeProvider,
  createTheme,
  AppBar
} from '@mui/material';
import { salaryTDSSettingsApi } from '../../../Data/axios';

const SalaryTds = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [salaryTdsData, setSalaryTdsData] = useState({
    annualSalaryFrom: '',
    annualSalaryUpto: '',
    salaryPercent: '',
  });
  const [statusData, setStatusData] = useState({
    applyIfAnnualSalary: '',
    financialYearStart: '',
    status: 'Active',
  });
  const [salaryTdsGroups, setSalaryTdsGroups] = useState([]);
  const [currentTds, setCurrentTds] = useState(null);

  // Fetch all salary TDS groups
  const fetchSalaryTdsGroups = async () => {
    try {
      const response = await salaryTDSSettingsApi.getAll();
      setSalaryTdsGroups(response.data);
      console.log(response)
    } catch (error) {
      console.error("Error fetching salary TDS groups:", error);
    }
  };

  // Add or update salary TDS group
  const handleSaveSalaryTdsGroup = async () => {
    try {
      const formData = new FormData();
      formData.append("annualSalaryFrom", salaryTdsData.annualSalaryFrom);
      formData.append("annualSalaryUpto", salaryTdsData.annualSalaryUpto);
      formData.append("salaryPercent", salaryTdsData.salaryPercent);

      if (currentTds) {
        // Update existing TDS
        await salaryTDSSettingsApi.update(currentTds.id, formData);
      } else {
        // Add new TDS
        await salaryTDSSettingsApi.add(formData);
      }

      fetchSalaryTdsGroups(); // Refresh the data
      setOpenDialog(false);
      setSalaryTdsData({ annualSalaryFrom: '', annualSalaryUpto: '', salaryPercent: '' });
      setCurrentTds(null);
    } catch (error) {
      console.error("Error saving salary TDS group:", error);
    }
  };

  // Handle delete
  const handleDeleteSalaryTdsGroup = async (id) => {
    try {
      await salaryTDSSettingsApi.delete(id);
      fetchSalaryTdsGroups();
    } catch (error) {
      console.error("Error deleting salary TDS group:", error);
    }
  };

  // Handle edit
  const handleEditSalaryTdsGroup = (group) => {
    setCurrentTds(group);
    setSalaryTdsData({
      annualSalaryFrom: group.annualSalaryFrom,
      annualSalaryUpto: group.annualSalaryUpto,
      salaryPercent: group.salaryPercent,
    });
    setOpenDialog(true);
  };

  // Add salary TDS status
  const handleAddSalaryTdsStatus = async () => {
    try {
      const formData = new FormData();
      formData.append("applyIfAnnualSalary", statusData.applyIfAnnualSalary);
      formData.append("financialYearStart", statusData.financialYearStart);
      formData.append("status", statusData.status);

      await salaryTDSSettingsApi.add(formData);
      setOpenStatusDialog(false);
      setStatusData({ applyIfAnnualSalary: '', financialYearStart: '', status: 'Active' });
    } catch (error) {
      console.error("Error adding salary TDS status:", error);
    }
  };

  useEffect(() => {
    fetchSalaryTdsGroups();
  }, []);

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
    });

  return (
    <ThemeProvider theme={getTheme()}>
      <div style={{ padding: '20px' }}>
        <Button variant="contained" color="primary" onClick={() => setOpenDialog(true)}sx={{"&:hover": { backgroundColor: "orange" },}}>
          Add Salary TDS
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpenStatusDialog(true)}
          style={{ marginLeft: '10px' }}
          sx={{"&:hover": { backgroundColor: "orange" },}}
        >
          Salary TDS Status
        </Button>

        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Annual Salary From</TableCell>
                <TableCell>Annual Salary Upto</TableCell>
                <TableCell>Salary Percent</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {salaryTdsGroups.length > 0 ? (
                salaryTdsGroups.map((group) => (
                  <TableRow key={group.id}>
                    <TableCell>{group.annual_salary_from}</TableCell>
                    <TableCell>{group.annual_salary_to}</TableCell>
                    <TableCell>{group.percent}</TableCell>
                    <TableCell>
                      <Button color="primary" onClick={() => handleEditSalaryTdsGroup(group)} variant="outlined" sx={{marginRight:"5px"}}>
                        Edit
                      </Button>
                      <Button color="secondary" onClick={() => handleDeleteSalaryTdsGroup(group.id)} variant="outlined">
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    - No salary TDS added. -
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Add/Edit Salary TDS Dialog */}
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
          <DialogTitle sx={{color:"white"}}>{currentTds ? 'Edit' : 'Add'} Salary TDS</DialogTitle>
        </AppBar>
          <DialogContent>
            <TextField
              fullWidth
              label="Annual Salary From"
              margin="normal"
              value={salaryTdsData.annualSalaryFrom}
              onChange={(e) => setSalaryTdsData({ ...salaryTdsData, annualSalaryFrom: e.target.value })}
            />
            <TextField
              fullWidth
              label="Annual Salary Upto"
              margin="normal"
              value={salaryTdsData.annualSalaryUpto}
              onChange={(e) => setSalaryTdsData({ ...salaryTdsData, annualSalaryUpto: e.target.value })}
            />
            <TextField
              fullWidth
              label="Salary Percent"
              margin="normal"
              value={salaryTdsData.salaryPercent}
              onChange={(e) => setSalaryTdsData({ ...salaryTdsData, salaryPercent: e.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} color="secondary" sx={{color:"grey"}}>
              Cancel
            </Button>
            <Button onClick={handleSaveSalaryTdsGroup} color="primary" variant="contained" sx={{"&:hover": { backgroundColor: "orange" },}}>
              {currentTds ? 'Update' : 'Add'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Add Salary TDS Status Dialog */}
        <Dialog open={openStatusDialog} onClose={() => setOpenStatusDialog(false)} fullWidth maxWidth="sm">
        <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
          <DialogTitle sx={{color:"white"}}>Salary TDS Status</DialogTitle>
        </AppBar>
          <DialogContent>
            <TextField
              fullWidth
              label="Apply If Annual Salary is More Than ($ USD)"
              margin="normal"
              value={statusData.applyIfAnnualSalary}
              onChange={(e) => setStatusData({ ...statusData, applyIfAnnualSalary: e.target.value })}
            />
            <TextField
              fullWidth
              label="Financial Year Start Month"
              margin="normal"
              value={statusData.financialYearStart}
              onChange={(e) => setStatusData({ ...statusData, financialYearStart: e.target.value })}
            />
            <RadioGroup
              row
              value={statusData.status}
              onChange={(e) => setStatusData({ ...statusData, status: e.target.value })}
            >
              <FormControlLabel value="Active" control={<Radio />} label="Active" />
              <FormControlLabel value="Inactive" control={<Radio />} label="Inactive" />
            </RadioGroup>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenStatusDialog(false)} color="secondary" sx={{color:"grey"}}>
              Cancel
            </Button>
            <Button onClick={handleAddSalaryTdsStatus} color="primary" variant="contained" sx={{"&:hover": { backgroundColor: "orange" },}}>
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  );
};

export default SalaryTds;
